import { useQuery } from '@tanstack/react-query';
import { getMe } from '@/data/client';
import { ApiError } from '@/data/api';

export function useMe() {
  const q = useQuery({
    queryKey: ['me'],
    queryFn: getMe,
    staleTime: 5 * 60_000,
    // A 403 is an answer (not invited), not a transient failure.
    retry: (n, err) => !(err instanceof ApiError && err.status < 500) && n < 2,
  });
  const notInvited = q.error instanceof ApiError && q.error.code === 'not_invited';
  return { me: q.data, isLoading: q.isLoading, notInvited, error: q.error };
}
